import React from 'react';

const POST_FOOTER_CLASS = 'post-footer';

export const getPostFooterTop = () => {
  const postFooter = document.querySelector(`.${POST_FOOTER_CLASS}`);
  const isPostFooterVisible =
    postFooter != null && getComputedStyle(postFooter).display !== 'none';
  const postFooterRect = postFooter?.getBoundingClientRect();
  return isPostFooterVisible ? postFooterRect?.top ?? null : null;
};

interface PostFooterProps {
  children: React.ReactNode;
}

const PostFooter = ({ children }: PostFooterProps) => {
  return <footer className={POST_FOOTER_CLASS}>{children}</footer>;
};

export default PostFooter;
